import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataService } from '@app-core/services/data/data.service';

@Component({
  selector: 'app-show-media-modal',
  templateUrl: './show-media-modal.component.html',
  styleUrls: ['./show-media-modal.component.scss'],
})
export class ShowMediaModalComponent implements OnInit {
  public isSpeedingLimitViolationEvent: boolean = false;
  public mediaUrl: string = '';

  public actualSpeedInKmph: number;
  public postedSpeedInKmph: number;
  public postedSpeedMediaUrl: string = '';

  constructor(@Inject(MAT_DIALOG_DATA) public data: any = {}, public dataService: DataService) {}

  public ngOnInit() {
    this.mediaUrl = this.data.eventVideoFilename;
    this.checkForSpeedLimitViolationEvent();
  }

  private checkForSpeedLimitViolationEvent() {
    this.isSpeedingLimitViolationEvent = this.data.eventType === 'Traffic-Speed-Violated';
    if (!this.isSpeedingLimitViolationEvent) {
      return;
    }
    const { speed: actualSpeedInMetersPerSecond = 0, speedSign: { speedSignValue = 0, eventVideoFilename = '' } = {} } = this.data || {};
    this.postedSpeedMediaUrl = eventVideoFilename;
    this.actualSpeedInKmph = actualSpeedInMetersPerSecond * 3.6;
    this.postedSpeedInKmph = speedSignValue;
  }
}
